<template>
  <main>
    <h2 class="ttl"><img src="/img/ico_user2.png" alt="会員情報の登録" width="40" class="mb30"><br>{{$t('registrationComplete')}}</h2>
    <p v-if="this.show" class="btn-normal-2 mt60"><a href="/">{{$t('topPage')}}</a></p>
    <div class="downloadApp">
      <span>{{$t('downloadApplication')}}</span>
      <div class="downloadImage" v-if="i18n.locale=='en'">
        <a href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"><img src="@/assets/img/apple-store-en.png" alt="Download Application"></a>
        <a href="https://play.google.com/store/apps/details?id=jp.choy_san"><img src="@/assets/img/google-play-en.png" alt="Download Application"></a>
      </div>
      <div class="downloadImage" v-if="i18n.locale=='ja'">
        <a href="https://apps.apple.com/jp/app/choy-san-%E8%AA%B0%E3%81%A7%E3%82%82%E3%83%97%E3%83%AA%E3%83%9A%E3%82%A4%E3%83%89%E3%82%AB%E3%83%BC%E3%83%89%E3%82%92%E4%BD%9C%E3%82%8C%E3%82%8B%E3%82%A2%E3%83%97%E3%83%AA/id1531999604"><img src="@/assets/img/apple-store-jp.png" alt="Download Application"></a>
        <a href="https://play.google.com/store/apps/details?id=jp.choy_san"><img src="@/assets/img/google-play-jp.png" alt="Download Application"></a>
      </div>
    </div>
  </main>
</template>

<script>
import firebase from 'firebase'
import redirectEnum from '@/constants/redirectEnum'
import i18n from '../../i18n'

export default {
  name: 'AccountProfileCreateCompleted',
  data () {
    return {
      i18n:i18n,
      db: firebase.firestore(),
      user: firebase.auth().currentUser,
      show:true,
    }
  },
  methods:{
    notAvailable(){
      window.alert(this.$t('downloadNotAvailable'));
    }
  },
  async created(){
    this.$parent.isLogin=true;
    const doc=await this.db.collection('users').doc(this.user.uid).get();
    const data=doc.data();
    if(data.redirectId!=undefined &&redirectEnum.redirects[data.redirectId]!==undefined &&data.pid==undefined) // Redirect exist
    {
      // redirect for chikyujin
      if(redirectEnum.redirects[data.redirectId].includes("http")){
        this.show=false;
        setTimeout(()=>{window.location.href=redirectEnum.redirects[data.redirectId]},1000);
      }
      else
      { //redirect for c.choysan pages
        this.show=false;
        this.$router.push({name: "Partner",query: { target: data.redirectId }});
      }
    }
  }
}
</script>
